/*
 *   File : text-button.js
 *   Author : https://evoqins.com
 *   Description : Text button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React from 'react';

//components
import { Icon } from '../Icon';

// styles
import color from '../../Style/color.scss';
import style from '../../Style/Component/text-button.module.scss';

const TextButton = (props) => {
    return (
        <div className={`${style.e_text_button} ${props.disabled?"pe-none opacity-75":""} d-flex align-items-center gap-1 ${props.cursorPointer ? props.cursorPointer : 'cursor-pointer'} `}
            data-bs-toggle={props.toggle}
            data-bs-target={props.target}
            data-bs-cancel={props.cancel}
            data-bs-dismiss={props.dismiss}
            disabled={props.disabled}
            icon={props.icon}
            id={props.id}
            onClick={(e) => props.onClick(e)}>
            {props.add &&
                <Icon icon={props.iconName ? props.iconName : 'add'}
                    size={props.iconSize ? props.iconSize : "1.5rem"}
                    color={props.iconColor}
                    className="d-flex" />
            }
            <span className={`${props.className} ${props.fontSize ? props.fontSize : 'e-font-14'} ${props.fontWeight ? props.fontWeight : 'e-font-weight-600'} e-text-blue-violet e-primary-font  line-height-16px`}>
                {props.name}
            </span>

            {props.icon &&
                <Icon icon='back'
                    size="1rem"
                    color={color.blue_violet}
                    className={`${style.e_back_icon} e-rotate-180 d-flex transition`} />
            }
        </div>

    )
}

export default TextButton;

TextButton.defaultProps = {
    onClick: () => { },
    className: null,
    id: null,
    name: null,
};